import React, { useEffect, useRef, useState } from "react";
import {
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "reactstrap";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import {
  createVehicle,
  getVehicleCategoryAllList,
  getVehicleFuelAllList,
  getvehicleMakeAllList,
  getVehiclePlateAllist,
  getVehicleTecEtaiDetails,
  getVehicleVinAllist,
  getvehicleYearList,
} from "../../services/VehicleService";
import moment from "moment";
import ConfigDB from "../../config";
import {
  actionAddDepollutionOpration,
  getLerCodeList,
} from "../../services/DepollutionService";

import {
  getAllViewMainShelfList,
  getAllViewShelfList,
} from "../../services/ShelfServices";
import { getVehicleAllModalSerachList } from "../../services/VehicleModelService";
import { getVehicleSerachVariantList } from "../../services/VehicleVariantsService";
import { getAllVehicleSerachType } from "../../services/VehicleMakeService";
import { getVehicleEngineSerachList } from "../../services/VehicleEngineService";
import { getCommonSearchList } from "../../services/settingsServices";
import { useTranslation } from "react-i18next";
import { tConstStatic } from "../../utils/constantsTranslator";

const VehicleSerachType = [
  { value: 1, labelKey: "vin_number" },
  { value: 2, labelKey: "plate_number" },
];

const Vehicles = ({
  setActiveTab,
  vehicleProcessList,
  setVehicleVinData,
  vehicleVinData,
  vehiclePlateData,
  countryAllData,
  AllvehicleSerachData,
  setAllVehicleSerachData,
  setVehiclePlateData,
  certificateDetails,
}) => {
  const [vehicleEngineId, setVehicleEngineId] = useState({
    vehicle_engine_id: "",
    vehicle_kw: "",
    vehicle_hp: "",
  });
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [VehicleEngineData, setVehicleEngineData] = useState("");
  const [vehicleData, setVehicleData] = useState({
    uuid: "",
    vehicle_owner_id: "",
    vehicle_process_start_date: "",
    vehicle_process_end_date: "",
    registration: "",
    registration_plate: "",
    vehicle_frame: AllvehicleSerachData.vin ? AllvehicleSerachData.vin : "",
    vehicle_model_id: "",
    vehicle_brand: "",
    vehicle_model: "",
    vehicle_booklet_model: "",
    vehicle_motorization: "",
    vehicle_category: "",
    vehicle_year: "",
    vehicle_kms: "",
    vehicle_engine: "",
    vehicle_approval: "",
    vehicle_total_gross_weight: "",
    vehicle_fuel: "",
    vehicle_parts: "",
    vehicle_color: "",
    vehicle_cyllinder: "",
    vehicle_type: "",
    vehicle_tare: "",
    vehicle_eei: "",
    vehicle_internl_ref: "",
    vehicle_external_ref: "",
    vehicle_exp_value: "",
    vehicle_provenance: "",
    shelf_id: "",
    vehicle_park: "",
    vehicle_park_name: "",
    status: "",
    certificate_sync_id: "",
    vehicle_make_etai: "",
    vehicle_model_etai: "",
    vehicle_variants_etai: "",
    motorization: "",
    ccm3: "",
    power_kw: "",
    hp: "",
    inventory_status: 1,
    deplllution_status: 1,
    dismental_status: 1,
    certificate_number: "",
    vehicle_year_id: "",
    make_id: "",
    variants_id: "",
    vehicle_make_name: "",
    vehicle_variants_name: "",
    vehicle_modal_name: "",
    vehicle_make_name_etai: "",
    vehicle_variants_name_etai: "",
    vehicle_modal_name_etai: "",
    vehicle_type_name: "",
    state_parking: "",
    vehicle_doors: "",
    vehicle_make_etai_name: "",
    vehicle_year_etai: "",
    steering_wheel_side: "1",
    initial_year: "",
    year_final: "",
  });

  const tableLengthList = ConfigDB.data.dataTableLength;

  const [serachModal, setSerachModal] = useState(false);
  const [serach, setSerach] = useState("");

  let errorsObj = {
    // vehicle_process_type: "",
    vehicle_process_start_date: "",
    vehicle_process_end_date: "",
    registration: "",
    registration_plate: "",
    vehicle_frame: "",
    vehicle_model_id: "",
    vehicle_brand: "",
    vehicle_booklet_model: "",
    vehicle_motorization: "",
    vehicle_category: "",
    vehicle_year: "",
    vehicle_kms: "",
    vehicle_engine: "",
    vehicle_approval: "",
    vehicle_total_gross_weight: "",
    vehicle_fuel: "",
    vehicle_parts: "",
    vehicle_color: "",
    vehicle_cyllinder: "",
    vehicle_type: "",
    vehicle_tare: "",
    vehicle_eei: "",
    vehicle_internl_ref: "",
    vehicle_external_ref: "",
    vehicle_exp_value: "",
    vehicle_provenance: "",
    shelf_id: "",
    // body_sent_to_waste: "",
    status: "",
    vehicle_model: "",
    vehicle_fuel_Type_description: "",
    vehicle_make_etai: "",
    vehicle_model_etai: "",

    vehicle_variants_etai: "",
    motorization: "",

    ccm3: "",
    power_kw: "",
    hp: "",
    inventory_status: "",
    deplllution_status: "",
    dismental_status: "",
    certificate_number: "",
    neutralization_date: "",
    decontamination_date: "",
    vehicle_arrival_date: "",
    sented_to_waste_date: "",
  };

  const [errors, setErrors] = useState(errorsObj);
  const [VehicleCategoryList, setVehicleCategoryList] = useState([]);
  const [VehicleFuelList, setVehicleFuelList] = useState([]);
  const [VehicleTypeList, setVehicleTypeList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [btnLoader, setbtnLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [bodyWasteModal, setBodyWasteModal] = useState(false);
  const [vehiclePartsData, setVehiclePartsData] = useState({
    vehicle_id: "",
    ler_code_id: "",
    wastege_value: "",
    description: "",
  });
  const [LerCatalogList, setLerCatalogList] = useState([]);
  const [LerCatalogHistoryList, setLerCatalogHistoryList] = useState([]);
  const [inputValueLer, setInputValueLer] = useState("");
  const [ShelfList, SetShelfList] = useState([]);
  const [filteredSuggestionsModel, setFilteredSuggestionsModel] = useState([]);
  const [activeSuggestionIndexModel, setActiveSuggestionIndexModel] =
    useState(0);
  const [showSuggestionsModel, setShowSuggestionsModel] = useState(false);
  const [vehicleModelAuto, setVehicleModelAuto] = useState("");
  const [vehicleModelId, setVehicleModelId] = useState({
    model_id: "",
    make_id: "",
  });
  const [vehicleEngineAuto, setVehicleEngineAuto] = useState("");

  let ownerId = localStorage.getItem("ownerList");
  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
  });

  const [viewModal, setViewModal] = useState(false);
  const [vehicleTecEtaiList, setVehicleTecEtaiList] = useState({});
  const [selectedOption, setSelectedOption] = useState("");

  const [selectedOptionCarTec, setSelectedOptionCarTec] = useState("");
  const [SelectedVehicleData, setSelectedVehicleData] = useState("");

  const [SelectedVehicleCarTecData, setSelectedVehicleCarTecData] =
    useState("");

  const [inventoryList, setInventoryList] = useState([]);
  const [deplllutionList, setDeplllutionList] = useState([]);
  const [dismentalList, setDismentalList] = useState([]);

  const [vehicleYearAuto, setVehicleYearAuto] = useState("");
  const [VehicleYearList, setVehicleYearList] = useState([]);
  const [inputSelctedeYearValue, setInputSelctedYearValue] = useState("");
  const [inputSelctedeYearETAIValue, setInputSelctedYearETAIValue] =
    useState("");

  const [VehicleMakeList, setVehicleMakeList] = useState([]);
  const [inputSelctedeMakeValue, setInputSelctedMakeValue] = useState("");
  const [VehicleModalList, setVehicleModalList] = useState([]);
  const [inputSelctedeModalValue, setInputSelctedModalValue] = useState("");
  const [VehicleVariantList, setVehicleVariantList] = useState([]);
  const [inputSelctededVariantValue, setInputSelctedVariantValue] =
    useState("");

  const [VehicleMakeETAIList, setVehicleMakeETAIList] = useState([]);
  const [inputSelctedeMakeETAIValue, setInputSelctedMakeETAIValue] =
    useState("");
  const [VehicleModalETAIList, setVehicleModalETAIList] = useState([]);
  const [inputSelctedeModalETAIValue, setInputSelctedModalETAIValue] =
    useState("");
  const [VehicleVariantETAIList, setVehicleVariantETAIList] = useState([]);
  const [inputSelctededVariantETAIValue, setInputSelctedVariantETAIValue] =
    useState("");

  const [VehicleEngineList, setVehicleEngineList] = useState([]);
  const [inputSelctededEngineValue, setInputSelctedEngineValue] = useState("");
  const [stateParkingList, setStateParkingList] = useState([]);
  const [vehicleDoorList, setVehicleDoorList] = useState([]);
  const [loadingSelect, setLoadingSelect] = useState(false);

  const vehicleTypeMapping = {
    1: "Car",
    2: "Van",
    3: "Motorcycle",
  };

  const vehicleCategoryMapping = {
    1: "L",
    2: "M1",
    3: "M2",
    4: "M3",
    5: "N1",
    6: "N2",
    7: "N3",
    8: "O",
  };

  const vehicleFuelTypeMapping = {
    1: "Gasolina",
    2: "Diesel",
    3: "Electric",
    4: "LPG",
  };

  const [selectedVehicleCategory, setSelectedVehicleCategory] = useState(null);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [selectedVehicleFuel, setSelectedVehicleFuel] = useState(null);
  const [vehicleShelfList, setVehicleShelfList] = useState([]);

  useEffect(() => {
    if (certificateDetails?.vehicle_type_id) {
      const mappedType = vehicleTypeMapping[certificateDetails.vehicle_type_id];
      const foundType = VehicleTypeList.find(
        (item) =>
          mappedType && item.label.toLowerCase() === mappedType.toLowerCase()
      );

      setSelectedVehicle(foundType || null);
    } else if (vehicleProcessList?.vehicle_type) {
      const foundType = VehicleTypeList.find(
        (item) => item.value === Number(vehicleProcessList.vehicle_type)
      );

      setSelectedVehicle(foundType || null);
    }
  }, [certificateDetails, vehicleProcessList]);

  useEffect(() => {
    if (selectedVehicle) {
      setVehicleData((prev) => ({
        ...prev,
        vehicle_type: selectedVehicle?.value || "",
      }));
    }
  }, [selectedVehicle]);

  const handleVehicleChange = (selectedOption) => {
    setSelectedVehicle(selectedOption);
    setVehicleData((prevData) => ({
      ...prevData,
      vehicle_type: selectedOption ? selectedOption.value : "",
      make_id: "",
      vehicle_model_id: "",
      variants_id: "",
    }));

    setVehicleMakeList([]);
    setVehicleModalList([]);
    setVehicleVariantList([]);
  };

  useEffect(() => {
    if (VehicleEngineData) {
      setVehicleData((prev) => ({
        ...prev,
        vehicle_cyllinder: VehicleEngineData?.cyl || "",
        power_kw: VehicleEngineData?.kw || "",
        hp: VehicleEngineData?.hp || "",
      }));
    }
  }, [VehicleEngineData]);

  useEffect(() => {
    if (certificateDetails?.vehicle_category_id) {
      const mappedCategory =
        vehicleCategoryMapping[certificateDetails.vehicle_category_id];
      const foundCategory = VehicleCategoryList.find(
        (item) =>
          mappedCategory &&
          item.label.toLowerCase() === mappedCategory.toLowerCase()
      );

      setSelectedVehicleCategory(foundCategory || null);
    } else if (vehicleProcessList?.vehicle_category) {
      const foundCategory = VehicleCategoryList.find(
        (item) => item.value === Number(vehicleProcessList.vehicle_category)
      );

      setSelectedVehicleCategory(foundCategory || null);
    }
  }, [certificateDetails, vehicleProcessList]);

  useEffect(() => {
    if (
      selectedVehicleCategory &&
      selectedVehicleCategory.value !== undefined
    ) {
      setVehicleData((prevData) => ({
        ...prevData,
        vehicle_category: selectedVehicleCategory.value,
      }));
    }
  }, [selectedVehicleCategory]);

  const handleVehicleCategoryChange = (selectedOption) => {
    setSelectedVehicleCategory(selectedOption || null);
    setVehicleData((prevData) => ({
      ...prevData,
      vehicle_category: selectedOption ? selectedOption.value : "",
    }));
  };

  useEffect(() => {
    if (certificateDetails?.vehicle_fuel_Type_id) {
      const mappedFuel =
        vehicleFuelTypeMapping[certificateDetails.vehicle_fuel_Type_id];
      const foundFuel = VehicleFuelList.find(
        (item) =>
          mappedFuel && item.label.toLowerCase() === mappedFuel.toLowerCase()
      );

      setSelectedVehicleFuel(foundFuel || null);
    } else if (vehicleProcessList?.vehicle_fuel) {
      const foundFuel = VehicleFuelList.find(
        (item) => item.value === Number(vehicleProcessList.vehicle_fuel)
      );

      setSelectedVehicleFuel(foundFuel || null);
    }
  }, [certificateDetails, vehicleProcessList]);

  useEffect(() => {
    setVehicleData((prevData) => ({
      ...prevData,
      vehicle_fuel: selectedVehicleFuel?.value || "",
    }));
  }, [selectedVehicleFuel]);

  const handleVehicleFuelChange = (selectedOption) => {
    setSelectedVehicleFuel(selectedOption);
    setVehicleData({
      ...vehicleData,
      vehicle_fuel: selectedOption ? selectedOption.value : "",
    });
  };

  useEffect(
    function () {
      if (vehicleData?.variants_id) {
        let data = {
          limit: 20,
          page: params.page,
          search: "",
          is_reload: true,
          variants_id: vehicleData?.variants_id,
          model_id: vehicleData.vehicle_model_id,
        };
        getVehicleEngineSerachList(data)
          .then((response) => {
            response = response.data;
            let list = [];
            for (let i = 0; i < response.data.length; i++) {
              list.push({
                value: response.data[i].id,
                label: response.data[i].motor_code,
                kw: response.data[i]?.kw,
                hp: response.data[i]?.hp,
                cyl: response.data[i]?.cyl,
              });
            }
            setVehicleEngineList(list);
          })
          .catch((err) => {});
      }
    },
    [vehicleData?.variants_id]
  );

  const handleInputSelectedChangeEngineList = (inputSelctededEngineValue) => {
    setInputSelctedEngineValue(inputSelctededEngineValue);

    if (inputSelctededEngineValue.length > 0) {
      const obj = {
        page: 1,

        limit: 20,
        page: params.page,
        search: inputSelctededEngineValue,
        is_reload: true,
        variants_id: vehicleData?.variants_id,
        model_id: vehicleData.vehicle_model_id,
      };

      getVehicleEngineSerachList(obj)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].motor_code,
              kw: response.data[i]?.kw,
              hp: response.data[i]?.hp,
              cyl: response.data[i]?.cyl,
            });
          }
          setVehicleEngineList(list);
        })
        .catch((err) => {});
    }
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: params.page,
      search: "",
      is_reload: true,
    };
    getvehicleYearList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i],
            label: response.data[i],
          });
        }
        setVehicleYearList(list);
      })
      .catch((err) => {});
  }, []);

  const handleInputSelectedChangeYearList = (inputSelctedeYearValue) => {
    setInputSelctedYearValue(inputSelctedeYearValue);
    const obj = {
      search: inputSelctedeYearValue,
      limit: 20,
      page: 1,
    };

    getvehicleYearList(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i],
            label: response.data[i],
          });
        }
        setVehicleYearList(list);
      })
      .catch((err) => {});
  };

  const handleInputSelectedChangeYearEtaiList = () => {
    setInputSelctedYearETAIValue(inputSelctedeYearETAIValue);
    const obj = {
      search: inputSelctedeYearETAIValue,
      limit: 20,
      page: 1,
    };

    getvehicleYearList(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i],
            label: response.data[i],
          });
        }
        setVehicleYearList(list);
      })
      .catch((err) => {});
  };

  useEffect(
    function () {
      if (vehicleData?.vehicle_year_id) {
        let data = {
          limit: 20,
          page: params.page,
          search: vehicleData?.vehicle_make_name
            ? vehicleData.vehicle_make_name
            : inputSelctedeMakeValue,
          year: vehicleData?.vehicle_year_id,
          vehicle_type_id: vehicleData?.vehicle_type,
          is_reload: true,
        };
        getvehicleMakeAllList(data)
          .then((response) => {
            response = response.data;
            let list = [];
            for (let i = 0; i < response.data.length; i++) {
              list.push({
                value: response.data[i]?.id,
                label: response.data[i]?.description,
              });
            }
            setVehicleMakeList(list);
          })
          .catch((err) => {});
      }
    },
    [vehicleData?.vehicle_year_id, inputSelctedeMakeValue]
  );

  useEffect(() => {
    if (vehicleData) {
      setInputSelctedMakeValue(vehicleData.vehicle_make_name);
      setInputSelctedModalValue(vehicleData?.vehicle_modal_name);
      setInputSelctedVariantValue(vehicleData?.vehicle_variants_name);
      setInputSelctedMakeETAIValue(vehicleData?.vehicle_make_name_etai);
      setInputSelctedModalETAIValue(vehicleData?.vehicle_modal_name_etai);
      setInputSelctedVariantETAIValue(vehicleData?.vehicle_variants_name_etai);
    }
  }, [vehicleData]);

  const handleInputSelectedChangeMakeList = (inputSelctedeMakeValue) => {
    setInputSelctedMakeValue(inputSelctedeMakeValue);
    // if (inputSelctedeMakeValue.length > 0) {
    const obj = {
      limit: 20,
      page: params.page,
      search: inputSelctedeMakeValue,
      year: vehicleData?.vehicle_year_id,
      vehicle_type_id: vehicleData?.vehicle_type,
      is_reload: true,
    };

    getvehicleMakeAllList(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i]?.id,
            label: response.data[i]?.description,
          });
        }
        setVehicleMakeList(list);
      })
      .catch((err) => {});
    // }
  };

  useEffect(
    function () {
      if (vehicleData?.make_id) {
        let data = {
          limit: 20,
          page: params.page,
          search: vehicleData?.vehicle_modal_name
            ? vehicleData?.vehicle_modal_name
            : inputSelctedeModalValue,
          vehicle_year: vehicleData?.vehicle_year_id,
          make_id: Number(vehicleData?.make_id),
          vehicle_type_id: vehicleData?.vehicle_type,

          ...(vehicleTecEtaiList?.tecDoc && { etai_search: 1 }),
          is_reload: true,
        };

        getVehicleAllModalSerachList(data)
          .then((response) => {
            response = response.data;
            let list = [];
            for (let i = 0; i < response.data.length; i++) {
              list.push({
                value: response.data[i]?.id,
                label: response.data[i]?.model_name,
              });
            }
            setVehicleModalList(list);
          })
          .catch((err) => {});
      }
    },
    [vehicleData, inputSelctedeModalValue, vehicleTecEtaiList]
  );

  const handleInputSelectedChangeModalList = (inputSelctedeModalValue) => {
    setInputSelctedModalValue(inputSelctedeModalValue);
    // if (inputSelctedeModalValue.length > 0) {
    const obj = {
      limit: 20,
      page: params.page,
      search: inputSelctedeModalValue,
      make_id: vehicleData?.make_id,
      vehicle_year: vehicleData?.vehicle_year_id,
      vehicle_type_id: vehicleData?.vehicle_type,
      ...(vehicleTecEtaiList?.tecDoc && { etai_search: 1 }),

      is_reload: true,
    };

    getVehicleAllModalSerachList(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i]?.id,
            label: response.data[i]?.model_name,
          });
        }
        setVehicleModalList(list);
      })
      .catch((err) => {});
    // }
  };

  useEffect(
    function () {
      if (vehicleData?.vehicle_model_id) {
        let data = {
          limit: 20,
          page: params.page,
          search: vehicleData?.variants_name
            ? vehicleData?.variants_name
            : inputSelctededVariantValue,
          vehicle_year: vehicleData?.vehicle_year_id,
          model_id: vehicleData.vehicle_model_id,
          vehicle_type_id: vehicleData?.vehicle_type,
          ...(vehicleTecEtaiList?.tecDoc && { etai_search: 1 }),

          is_reload: true,
        };
        getVehicleSerachVariantList(data)
          .then((response) => {
            response = response.data;
            let list = [];
            for (let i = 0; i < response.data.length; i++) {
              list.push({
                value: response.data[i]?.id,
                label: response.data[i]?.variants_name,
                initial_year: response.data[i]?.initial_year,
                year_final: response?.data[i]?.year_final,
              });
            }
            setVehicleVariantList(list);
          })
          .catch((err) => {});
      }
    },
    [vehicleData, inputSelctededVariantValue, vehicleTecEtaiList]
  );

  const handleInputSelectedChangeVariantList = (inputSelctededVariantValue) => {
    setInputSelctedVariantValue(inputSelctededVariantValue);
    // if (inputSelctededVariantValue.length > 0) {
    const obj = {
      limit: 20,
      page: params.page,
      search: inputSelctededVariantValue,
      vehicle_year: vehicleData?.vehicle_year_id,
      model_id: vehicleData.vehicle_model_id,
      vehicle_type_id: vehicleData?.vehicle_type,
      ...(vehicleTecEtaiList?.tecDoc && { etai_search: 1 }),

      is_reload: true,
    };

    getVehicleSerachVariantList(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i]?.id,
            label: response.data[i]?.variants_name,
            initial_year: response.data[i]?.initial_year,
            year_final: response?.data[i]?.year_final,
          });
        }
        setVehicleVariantList(list);
      })
      .catch((err) => {});
    // }
  };

  const handleViewOpen = () => {
    setViewModal(true);
  };
  const handleViewClose = () => {
    setViewModal(false);
  };

  const handleOptionChange = (event, data) => {
    setSelectedOption(data?.vehicle_type_model_id_external);
    setSelectedVehicleData(data);
    // setSerachModal(false);
  };

  const handleOptionChangeCarsTec = (event, data) => {
    setSelectedOptionCarTec(data?.vehicle_type_model_id_catalog);
    setSelectedVehicleCarTecData(data);
    // setSerachModal(false);
  };

  const handleSelectEtaiDetails = async () => {
    if (!selectedOptionCarTec) {
      toast.error("Please select a car’s TecDoc details.");
      return;
    }

    try {
      setLoadingSelect(true);

      const data = {
        id_modelo_variante: selectedOptionCarTec,
        etai_enternal_id: 0,
      };

      const response = await getVehicleTecEtaiDetails(data);
      setVehicleTecEtaiList(response.data.data);
      setSerachModal(false);
    } catch (err) {
      toast.error("Failed to fetch vehicle details");
    } finally {
      setLoadingSelect(false);
    }
  };
  const handleClickModel = (suggestion) => {
    setVehicleModelId({
      model_id: suggestion?.id,
      make_id: suggestion?.make_id,
    });
    setVehicleModelAuto(suggestion.model_name);
    setFilteredSuggestionsModel([]);
    setShowSuggestionsModel(false);
  };

  const handleKeyDownModel = (e) => {
    if (e.key === "ArrowDown") {
      if (
        filteredSuggestionsModel &&
        activeSuggestionIndexModel < filteredSuggestionsModel?.length - 1
      ) {
        setActiveSuggestionIndexModel(activeSuggestionIndexModel + 1);
      }
    } else if (e.key === "ArrowUp") {
      if (activeSuggestionIndexModel > 0) {
        setActiveSuggestionIndexModel(activeSuggestionIndexModel - 1);
      }
    } else if (e.key === "Enter") {
      setVehicleModelAuto(filteredSuggestionsModel[activeSuggestionIndexModel]);
      setShowSuggestionsModel(false);
      setFilteredSuggestionsModel([]);
    }
  };

  const handleBodyWasteOpen = () => {
    setBodyWasteModal(true);
  };

  const handleBodyWasteClose = () => {
    setBodyWasteModal(false);
  };

  const handleSelectLERChange = (selectedOption) => {
    setVehiclePartsData({
      ...vehiclePartsData,
      ler_code_id: selectedOption ? selectedOption.value : "",
    });
  };

  const fetchShelfList = (search) => {
    const obj = {
      search,
      limit: 20,
      page: 1,
      park_id: 0,
    };

    getAllViewShelfList(obj)
      .then((response) => {
        const list = response.data.data.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        SetShelfList(list);
      })
      .catch(console.error);
  };

  useEffect(() => {
    fetchShelfList("");
  }, []);

  useEffect(function () {
    var obj = {
      search: "",
      limit: 20,
      page: 1,
    };
    getLerCodeList(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].ler_code,
          });
        }
        setLerCatalogList(list);
      })
      .catch((err) => {});
  }, []);

  const handleInputChangeLER = (inputValueLer) => {
    setInputValueLer(inputValueLer);

    if (inputValueLer.length > 2) {
      const obj = {
        search: inputValueLer,
        limit: 20,
        page: 1,
      };

      getLerCodeList(obj)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].ler_code,
            });
          }
          setLerCatalogList(list);
        })
        .catch((err) => {});
    } else {
      setLerCatalogList([]);
      const obj = {
        search: "",
        limit: 20,
        page: 1,
      };

      getLerCodeList(obj)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].ler_code,
            });
          }
          setLerCatalogList(list);
        })
        .catch((err) => {});
    }
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "part_inventory",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setInventoryList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "state_parking",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setStateParkingList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "vehicle_no_door",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setVehicleDoorList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "depollution",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setDeplllutionList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "dismental",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setDismentalList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    getVehicleCategoryAllList()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].category,
          });
        }
        setVehicleCategoryList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    getVehicleFuelAllList()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].fuel_type,
          });
        }
        setVehicleFuelList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    const obj = {
      search: "",
      limit: 20,
      page: 1,
    };
    getAllVehicleSerachType(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].vehicle_type_name,
          });
        }
        setVehicleTypeList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    if (vehicleData?.vehicle_type && VehicleTypeList.length > 0) {
      const preSelected = VehicleTypeList.find(
        (item) => item.value === vehicleData.vehicle_type
      );

      if (preSelected) {
        setSelectedVehicle(preSelected);
      }
    }
  }, [vehicleData?.vehicle_type, VehicleTypeList]);

  useEffect(
    function () {
      if (vehicleData?.vehicle_park) {
        const obj = {
          search: "",
          limit: 20,
          page: 1,
          park_id: vehicleData?.vehicle_park ? vehicleData?.vehicle_park : "",
        };
        getAllViewMainShelfList(obj)
          .then((response) => {
            response = response.data;
            let list = [];
            for (let i = 0; i < response.data.length; i++) {
              list.push({
                value: response.data[i].id,
                label: response.data[i].name,
              });
            }
            setVehicleShelfList(list);
          })
          .catch((err) => {});
      }
    },
    [vehicleData]
  );

  useEffect(() => {
    if (vehicleProcessList && Object.keys(vehicleProcessList)?.length > 0) {
      setVehicleData((prevData) => ({
        ...prevData,
        certificate_sync_id: vehicleProcessList.certificate_sync_id,
        vehicle_owner_id: vehicleProcessList.vehicle_owner_id,
        // vehicle_process_type: vehicleProcessList.vehicle_process_type,
        vehicle_process_start_date: moment(
          vehicleProcessList.vehicle_process_start_date
        ).format("YYYY-MM-DD"),
        vehicle_process_end_date: moment(
          vehicleProcessList.vehicle_process_end_date
        ).format("YYYY-MM-DD"),
        registration: vehicleProcessList.registration,
        registration_plate: vehicleProcessList.registration_plate,
        vehicle_frame: vehicleProcessList.vehicle_frame,
        vehicle_model_id: vehicleProcessList.vehicle_model_id,
        vehicle_year_id: vehicleProcessList.vehicle_year_id,
        make_id: vehicleProcessList.make_id,
        variants_id: vehicleProcessList.variants_id,
        vehicle_brand: vehicleProcessList.vehicle_brand,
        vehicle_model: vehicleProcessList.vehicle_model,
        vehicle_booklet_model: vehicleProcessList.vehicle_booklet_model,
        vehicle_motorization: vehicleProcessList.vehicle_motorization,
        vehicle_category: vehicleProcessList.vehicle_category,
        vehicle_year: vehicleProcessList.vehicle_year,
        vehicle_kms: vehicleProcessList.vehicle_kms,
        vehicle_engine: vehicleProcessList.vehicle_engine,
        vehicle_approval: vehicleProcessList.vehicle_approval,
        vehicle_total_gross_weight:
          vehicleProcessList.vehicle_total_gross_weight,
        vehicle_fuel: vehicleProcessList.vehicle_fuel,
        vehicle_parts: vehicleProcessList.vehicle_parts,
        vehicle_color: vehicleProcessList.vehicle_color,
        vehicle_cyllinder: vehicleProcessList.vehicle_cyllinder,
        vehicle_type: vehicleProcessList.vehicle_type,
        vehicle_tare: vehicleProcessList.vehicle_tare,
        vehicle_eei: vehicleProcessList.vehicle_eei,
        vehicle_internl_ref: vehicleProcessList.vehicle_internl_ref,
        vehicle_external_ref: vehicleProcessList.vehicle_external_ref,
        vehicle_exp_value: vehicleProcessList.vehicle_exp_value,
        vehicle_provenance: vehicleProcessList.vehicle_provenance,
        shelf_id: vehicleProcessList.shelf_id,
        vehicle_park: vehicleProcessList?.vehicle_park,
        vehicle_park_name: vehicleProcessList?.vehicle_park_name,
        vehicle_make_etai: vehicleProcessList.vehicle_make_etai,
        vehicle_model_etai: vehicleProcessList.vehicle_model_etai,
        vehicle_variants_etai: vehicleProcessList.vehicle_variants_etai,
        motorization: vehicleProcessList.motorization,
        ccm3: vehicleProcessList.ccm3,
        power_kw: vehicleProcessList.power_kw,
        hp: vehicleProcessList.hp,
        inventory_status: vehicleProcessList.inventory_status,
        deplllution_status: vehicleProcessList.deplllution_status,
        dismental_status: vehicleProcessList.dismental_status,
        certificate_number: vehicleProcessList?.certificate_number,
        state_parking: vehicleProcessList?.state_parking,
        vehicle_doors: vehicleProcessList?.vehicle_doors,
        vehicle_make_etai_name: vehicleProcessList?.vehicle_make_etai_name,
        vehicle_year_etai: vehicleProcessList?.vehicle_year_etai,
        steering_wheel_side:
          vehicleProcessList?.steering_wheel_side?.toString() || "1",
        vehicle_make_name: vehicleProcessList?.vehicle_make_name,
        initial_year: vehicleProcessList?.initial_year,
        year_final:
          vehicleProcessList?.year_final &&
          vehicleProcessList.year_final !== "0"
            ? vehicleProcessList.year_final
            : 2025,
        neutralization_date: moment(
          vehicleProcessList?.neutralization_date || new Date()
        ).format("YYYY-MM-DD"),

        decontamination_date: moment(
          vehicleProcessList?.decontamination_date || new Date()
        ).format("YYYY-MM-DD"),

        vehicle_arrival_date: moment(
          vehicleProcessList?.vehicle_arrival_date || new Date()
        ).format("YYYY-MM-DD"),

        sented_to_waste_date: moment(
          vehicleProcessList?.sented_to_waste_date || new Date()
        ).format("YYYY-MM-DD"),

        vehicle_modal_name: vehicleProcessList?.vehicle_model_name,
      }));

      setVehicleEngineAuto(vehicleProcessList?.engine_name);
      setVehicleEngineId({
        vehicle_engine_id: vehicleProcessList?.vehicle_engine,
        vehicle_kw: vehicleProcessList?.power_kw,
        vehicle_hp: vehicleProcessList?.hp,
        vehicle_cyllinder: vehicleProcessList?.vehicle_cyllinder,
      });
    }
  }, [vehicleProcessList]);

  // useEffect(() => {
  //   if (vehicleTecEtaiList?.tecDoc) {
  //     const tecDocData = {
  //       vehicle_model_id: Number(vehicleTecEtaiList.tecDoc.id_modelo),
  //       variants_id: vehicleTecEtaiList.tecDoc.id_modelo_variante,
  //       make_id: Number(vehicleTecEtaiList.tecDoc.id_marca),
  //       vehicle_make_name: vehicleTecEtaiList?.tecDoc?.make_description,
  //       vehicle_year_id: vehicleTecEtaiList?.tecDoc?.vehicle_year,
  //       vehicle_type: Number(vehicleTecEtaiList?.tecDoc?.vehicle_type_id),
  //       vehicle_variants_name: vehicleTecEtaiList?.tecDoc?.variant_description,
  //       vehicle_modal_name: vehicleTecEtaiList?.tecDoc?.model_description,
  //       vehicle_type_name: vehicleTecEtaiList?.tecDoc?.vehicle_type_name,
  //     };

  //     setVehicleData((prevData) => ({
  //       ...prevData,
  //       ...tecDocData,
  //     }));
  //   }

  //   // if (vehicleTecEtaiList?.Etai) {
  //   //   const etaiData = {
  //   //     vehicle_model_etai: Number(vehicleTecEtaiList.Etai.model_etai_id),
  //   //     vehicle_variants_etai: Number(vehicleTecEtaiList.Etai.variants_etai_id),
  //   //     vehicle_make_etai: Number(vehicleTecEtaiList.Etai.make_etai_id),
  //   //     vehicle_year_etai: SelectedVehicleData?.vehicle_model_fromYear,
  //   //     vehicle_make_name_etai: vehicleTecEtaiList.Etai.make_etai_description,
  //   //     vehicle_variants_name_etai:
  //   //       vehicleTecEtaiList.Etai.variant_etai_description,
  //   //     vehicle_modal_name_etai: vehicleTecEtaiList.Etai.model_etai_description,
  //   //   };

  //   //   setVehicleData((prevData) => ({
  //   //     ...prevData,
  //   //     ...etaiData, // Update Etai-related fields
  //   //   }));
  //   // } else
  //   if (SelectedVehicleData && SelectedVehicleCarTecData) {
  //     setVehicleData((prevData) => ({
  //       ...prevData,
  //       vehicle_year_id: SelectedVehicleData.vehicle_model_fromYear,
  //       vehicle_total_gross_weight:
  //         SelectedVehicleCarTecData.vehicle_type_weightEmpty,
  //       vehicle_color: SelectedVehicleCarTecData.vehicle_type_colour,
  //       vehicle_cyllinder: SelectedVehicleData.vehicle_type_cyl,
  //     }));

  //     setVehicleYearAuto(SelectedVehicleData.vehicle_model_fromYear);

  //     //       setVehicleModelAuto(SelectedVehicleCarTecData?.vehicle_type_model);
  //     // setVehicleModelId({
  //     //   model_id:SelectedVehicleCarTecData?.vehicle_type_model_id_catalog,

  //     // })
  //   }

  //   if (AllvehicleSerachData?.vin) {
  //     setVehicleData((prevData) => ({
  //       ...prevData,
  //     }));
  //   }

  //   if (AllvehicleSerachData.plate) {
  //     setVehicleData((prevData) => ({
  //       ...prevData,
  //       registration_plate: AllvehicleSerachData?.plate,
  //       registration: AllvehicleSerachData?.country,
  //     }));
  //   }
  // }, [vehicleTecEtaiList, SelectedVehicleData, SelectedVehicleCarTecData]);

  useEffect(() => {
    let updatedData = {};
    const tecDoc = vehicleTecEtaiList?.tecDoc;

    if (tecDoc) {
      updatedData = {
        ...updatedData,
        vehicle_model_id: Number(tecDoc.id_modelo),
        variants_id: tecDoc.id_modelo_variante,
        make_id: Number(tecDoc.id_marca),
        vehicle_make_name: tecDoc.make_description,
        // only use tecDoc.vehicle_year if vehicleData.vehicle_year_id not set
        vehicle_year_id:
          vehicleData?.vehicle_year && vehicleData.vehicle_year !== ""
            ? vehicleData.vehicle_year
            : tecDoc.vehicle_year,
        vehicle_type: Number(tecDoc.vehicle_type_id),
        vehicle_variants_name: tecDoc.variant_description,
        vehicle_modal_name: tecDoc.model_description,
        vehicle_type_name: tecDoc.vehicle_type_name,
        vehicle_year: vehicleData?.vehicle_year,
        initial_year: tecDoc?.initial_year,
        year_final: tecDoc?.year_final,
      };
    }

    if (SelectedVehicleData && SelectedVehicleCarTecData) {
      updatedData = {
        ...updatedData,
        vehicle_year_id:
          vehicleData?.vehicle_year_id ||
          SelectedVehicleData.vehicle_model_fromYear,
        vehicle_total_gross_weight:
          SelectedVehicleCarTecData.vehicle_type_weightEmpty,
        vehicle_color: SelectedVehicleCarTecData.vehicle_type_colour,
        vehicle_cyllinder: SelectedVehicleData.vehicle_type_cyl,
      };

      // Also reflect the same logic in setVehicleYearAuto
      setVehicleYearAuto(
        vehicleData?.vehicle_year_id ||
          SelectedVehicleData.vehicle_model_fromYear
      );
    }

    if (AllvehicleSerachData) {
      updatedData = {
        ...updatedData,
        ...(AllvehicleSerachData.vin
          ? {}
          : {
              registration_plate: AllvehicleSerachData?.plate,
              registration: AllvehicleSerachData?.country,
            }),
      };
    }

    if (Object.keys(updatedData).length > 0) {
      setVehicleData((prev) => ({ ...prev, ...updatedData }));
    }
  }, [
    vehicleTecEtaiList,
    SelectedVehicleData,
    SelectedVehicleCarTecData,
    AllvehicleSerachData,
  ]);

  useEffect(() => {
    if (certificateDetails) {
      const formattedDate = certificateDetails?.certificate_date
        ? new Date(certificateDetails.certificate_date)
            .toISOString()
            .split("T")[0]
        : "";

      const processEndDate = certificateDetails?.certificate_date
        ? new Date(
            new Date(certificateDetails.certificate_date).setFullYear(
              new Date(certificateDetails.certificate_date).getFullYear() + 1
            )
          )
            .toISOString()
            .split("T")[0]
        : "";

      const newVehicleData = {
        registration: certificateDetails.is_foreign
          ? certificateDetails.registration
          : certificateDetails.country_text || "Portugal",
        registration_plate: certificateDetails.registration_plate || "",
        certificate_number: certificateDetails.certificate_id || "",
        vehicle_process_start_date: formattedDate,
        vehicle_process_end_date: processEndDate,
        vehicle_total_gross_weight: certificateDetails.weight || "",
        vehicle_fuel_Type_description:
          certificateDetails.vehicle_fuel_Type_description || "",
        vehicle_color: certificateDetails.vehicle_color || "",
        vehicle_cyllinder: certificateDetails.vehicle_cyllinder || "",
        vehicle_tare: certificateDetails.weight || "",
        vehicle_eei: certificateDetails.vehicle_eei || "",
        vehicle_internl_ref: certificateDetails.vehicle_internl_ref || "",
        vehicle_external_ref: certificateDetails.vehicle_external_ref || "",
        vehicle_exp_value: certificateDetails.vehicle_exp_value || "",
        vehicle_provenance: certificateDetails.vehicle_provenance || "",
        shelf_id: certificateDetails.shelf_id || "",
        vehicle_frame: certificateDetails.chassis_serial_number || "",
        vehicle_booklet_model:
          certificateDetails.vehicle_model_description || "",
        vehicle_brand:
          certificateDetails.vehicle_manufacturer_description || "",
        vehicle_model: `${
          certificateDetails.vehicle_manufacturer_description || ""
        } ${certificateDetails.vehicle_model_description || ""}`.trim(),
        vehicle_year: certificateDetails.registration_plate_date
          ? new Date(certificateDetails.registration_plate_date).getFullYear()
          : "",
        vehicle_type: Number(certificateDetails?.vehicle_type_id),
      };

      setVehicleData((prev) => ({ ...prev, ...newVehicleData }));
      setAllVehicleSerachData({
        ...AllvehicleSerachData,
        vin: certificateDetails?.chassis_serial_number
          ? certificateDetails?.chassis_serial_number
          : AllvehicleSerachData.vin,
      });
    }
  }, [certificateDetails]);

  // useEffect(() => {
  //   if (AllvehicleSerachData?.vin) {
  //     setVehicleData((prevData) => ({
  //       ...prevData,
  //       vehicle_frame: AllvehicleSerachData.vin,
  //     }));
  //   }

  //   if (AllvehicleSerachData.plate) {
  //     setVehicleData((prevData) => ({
  //       ...prevData,
  //       registration_plate: AllvehicleSerachData?.plate,
  //       registration: AllvehicleSerachData?.country,
  //     }));
  //   }
  // }, [AllvehicleSerachData]);

  // useEffect(() => {
  //   if (SelectedVehicleData && SelectedVehicleCarTecData) {
  //     setVehicleData((prevData) => ({
  //       ...prevData,
  //       vehicle_year_id: SelectedVehicleData.vehicle_model_fromYear,
  //       vehicle_total_gross_weight:
  //         SelectedVehicleCarTecData.vehicle_type_weightEmpty,
  //       vehicle_color: SelectedVehicleCarTecData.vehicle_type_colour,
  //       vehicle_cyllinder: SelectedVehicleData.vehicle_type_cyl,
  //     }));

  //     setVehicleYearAuto(SelectedVehicleData.vehicle_model_fromYear);

  //     //       setVehicleModelAuto(SelectedVehicleCarTecData?.vehicle_type_model);
  //     // setVehicleModelId({
  //     //   model_id:SelectedVehicleCarTecData?.vehicle_type_model_id_catalog,

  //     // })
  //   }
  // }, [SelectedVehicleData, SelectedVehicleCarTecData]);

  const handleVehicleForm = (e) => {
    e.preventDefault();
    let error = false;
    let errorObj = { ...errorsObj };
    setbtnLoading(true);

    // if (isNaN(vehicleData.vehicle_year) || vehicleData.vehicle_year <= 0) {
    //   errorObj.vehicle_year = `Year must be a valid number`;
    //   error = true;
    //   setbtnLoading(false);
    // }

    if (!vehicleData?.vehicle_type) {
      errorObj.vehicle_type = "Vehicle type is required";
      error = true;
      setbtnLoading(false);
    }

    setErrors(errorObj);
    Utils.focusError();

    if (error) return;

    let data = {
      vehicle_owner_id: ownerId,
      // vehicle_process_type: vehicleData.vehicle_process_type,
      vehicle_process_start_date:
        vehicleData.vehicle_process_start_date ||
        new Date().toISOString().split("T")[0] ||
        "",

      vehicle_process_end_date:
        vehicleData.vehicle_process_end_date ||
        new Date().toISOString().split("T")[0] ||
        "",
      registration:
        certificateDetails.is_foreign === false
          ? "Portugal"
          : vehicleData.registration || "",
      registration_plate: vehicleData.registration_plate || "",
      vehicle_frame: vehicleData.vehicle_frame || "",
      vehicle_model_id: vehicleData?.vehicle_model_id || "",
      vehicle_year_id: vehicleData?.vehicle_year_id || "",
      make_id: vehicleData?.make_id,
      vehicle_brand: vehicleData.vehicle_brand || "",
      vehicle_model: vehicleData.vehicle_model || "",
      vehicle_booklet_model: vehicleData.vehicle_booklet_model || "",
      vehicle_motorization: vehicleData.vehicle_motorization || "",
      vehicle_category: selectedVehicleCategory
        ? selectedVehicleCategory?.value
        : vehicleData.vehicle_category || "",
      vehicle_year: vehicleData.vehicle_year_id || "",
      vehicle_kms: vehicleData.vehicle_kms || "",
      vehicle_engine: vehicleData?.vehicle_engine || "",
      vehicle_approval: vehicleData.vehicle_approval || "",
      vehicle_total_gross_weight: vehicleData.vehicle_total_gross_weight || "",
      vehicle_fuel: selectedVehicleFuel
        ? selectedVehicleFuel.value
        : vehicleData.vehicle_fuel || "",
      vehicle_parts: vehicleData.vehicle_parts || "",
      vehicle_color: vehicleData.vehicle_color || "",
      vehicle_type: vehicleData?.vehicle_type || "",
      vehicle_tare: vehicleData.vehicle_tare || "",
      vehicle_eei: vehicleData.vehicle_eei || "",
      vehicle_internl_ref: vehicleData.vehicle_internl_ref || "",
      vehicle_external_ref: vehicleData.vehicle_external_ref || "",
      vehicle_exp_value: vehicleData.vehicle_exp_value || "",
      vehicle_provenance: vehicleData.vehicle_provenance || "",
      shelf_id: vehicleData.shelf_id || "",
      vehicle_park: vehicleData.vehicle_park || "",
      // body_sent_to_waste: vehicleData.body_sent_to_waste,
      certificate_sync_id: certificateDetails?.id
        ? certificateDetails?.id
        : null,
      variants_id: vehicleData?.variants_id,
      etai_id: SelectedVehicleData?.vehicle_type_model_id_external
        ? SelectedVehicleData?.vehicle_type_model_id_external
        : 0,
      tec_doc_id: SelectedVehicleData?.vehicle_type_model_id_catalog
        ? SelectedVehicleData?.vehicle_type_model_id_catalog
        : 0,
      vin_number: AllvehicleSerachData ? AllvehicleSerachData.vin : 0,
      vehicle_make_etai: 0,
      vehicle_model_etai: 0,
      vehicle_variants_etai: 0,
      ccm3: vehicleData.ccm3 || "",
      vehicle_cyllinder: vehicleData.vehicle_cyllinder,

      power_kw: vehicleData.power_kw,
      hp: vehicleData.hp,
      inventory_status: vehicleData.inventory_status
        ? vehicleData.inventory_status
        : 1,
      deplllution_status: vehicleData.deplllution_status || "",
      dismental_status: vehicleData.dismental_status || "",
      certificate_number: vehicleData?.certificate_number || "",
      state_parking: vehicleData?.state_parking,
      vehicle_doors: vehicleData?.vehicle_doors,
      vehicle_year_etai: 0,
      steering_wheel_side: vehicleData?.steering_wheel_side,
      neutralization_date:
        vehicleData.neutralization_date0 ||
        new Date().toISOString().split("T")[0] ||
        "",
      decontamination_date:
        vehicleData.decontamination_date ||
        new Date().toISOString().split("T")[0] ||
        "",
      vehicle_arrival_date:
        vehicleData.vehicle_arrival_date ||
        new Date().toISOString().split("T")[0] ||
        "",
      sented_to_waste_date:
        vehicleData.sented_to_waste_date ||
        new Date().toISOString().split("T")[0] ||
        "",
    };

    let updateData = {
      vehicle_owner_id: vehicleProcessList?.vehicle_owner_id,
      uuid: vehicleProcessList?.uuid,
      // vehicle_process_type: vehicleData.vehicle_process_type,
      vehicle_process_start_date: vehicleData.vehicle_process_start_date,
      vehicle_process_end_date: vehicleData.vehicle_process_end_date,
      registration: vehicleData.registration,
      registration_plate: vehicleData.registration_plate,
      vehicle_frame: vehicleData.vehicle_frame,
      vehicle_model_id: vehicleData?.vehicle_model_id,
      make_id: vehicleData?.make_id,
      vehicle_brand: vehicleData.vehicle_brand,
      vehicle_model: vehicleData.vehicle_model,
      vehicle_booklet_model: vehicleData.vehicle_booklet_model,
      vehicle_motorization: vehicleData.vehicle_motorization,
      vehicle_category: vehicleData.vehicle_category,
      vehicle_year: vehicleData.vehicle_year,
      vehicle_kms: vehicleData.vehicle_kms,
      vehicle_engine: vehicleData?.vehicle_engine,
      vehicle_approval: vehicleData.vehicle_approval,
      vehicle_total_gross_weight: vehicleData.vehicle_total_gross_weight,
      vehicle_fuel: vehicleData.vehicle_fuel,
      vehicle_parts: vehicleData.vehicle_parts,
      vehicle_color: vehicleData.vehicle_color,
      vehicle_cyllinder: VehicleEngineData
        ? VehicleEngineData?.cyl
        : vehicleData.vehicle_cyllinder,
      vehicle_type: vehicleData?.vehicle_type,
      vehicle_tare: vehicleData.vehicle_tare,
      vehicle_eei: vehicleData.vehicle_eei,
      vehicle_internl_ref: vehicleData.vehicle_internl_ref,
      vehicle_external_ref: vehicleData.vehicle_external_ref,
      vehicle_exp_value: vehicleData.vehicle_exp_value,
      vehicle_provenance: vehicleData.vehicle_provenance,
      shelf_id: vehicleData.shelf_id,
      vehicle_park: vehicleData.vehicle_park,
      certificate_sync_id: vehicleData.certificate_sync_id
        ? vehicleData.certificate_sync_id
        : null,
      variants_id: vehicleData?.variants_id,
      etai_id: SelectedVehicleData?.vehicle_type_model_id_external
        ? SelectedVehicleData?.vehicle_type_model_id_external
        : 0,
      tec_doc_id: SelectedVehicleData?.vehicle_type_model_id_catalog
        ? SelectedVehicleData?.vehicle_type_model_id_catalog
        : 0,
      vin_number: vehicleProcessList ? vehicleProcessList.vin_number : 0,

      motorization: vehicleData.motorization,
      ccm3: vehicleData.ccm3,
      power_kw: VehicleEngineData
        ? VehicleEngineData?.kw
        : vehicleData.power_kw,
      hp: VehicleEngineData ? VehicleEngineData?.hp : vehicleData.hp,
      inventory_status: vehicleData.inventory_status,
      deplllution_status: vehicleData.deplllution_status,
      dismental_status: vehicleData.dismental_status,
      certificate_number: vehicleData?.certificate_number,
      vehicle_year_id: vehicleData?.vehicle_year_id,
      vehicle_make_etai: 0,
      vehicle_model_etai: 0,
      vehicle_variants_etai: 0,
      state_parking: vehicleData?.state_parking,
      vehicle_doors: vehicleData?.vehicle_doors,
      vehicle_year_etai: 0,
      steering_wheel_side: vehicleData?.steering_wheel_side,
      neutralization_date: vehicleData?.neutralization_date,
      decontamination_date: vehicleData?.decontamination_date,
      vehicle_arrival_date: vehicleData?.vehicle_arrival_date,
      sented_to_waste_date: vehicleData?.sented_to_waste_date,
    };

    if (vehicleProcessList?.uuid) {
      createVehicle(updateData)
        .then((response) => {
          toast.success(response.data.message);
          setActiveTab("vehicle_images");
          localStorage.setItem("vehicleId", response.data.data.id);
          setbtnLoading(false);
        })
        .catch((err) => {
          setbtnLoading(false);

          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setbtnLoading(false);
        });
    } else {
      createVehicle(data)
        .then((response) => {
          toast.success(response.data.message);
          setActiveTab("vehicle_images");
          localStorage.setItem("vehicleId", response.data.data.id);
          setbtnLoading(false);
        })
        .catch((err) => {
          setbtnLoading(false);

          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setbtnLoading(false);
        });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true); // Set loading state to true (start the loader)

    // Simulate an async operation like form processing or API call
    setTimeout(() => {
      setLoading(false); // Stop loading state after the async operation
    }, 1000);
    let data = {
      vehicle_id: vehicleProcessList?.id,
      ler_code_id: vehiclePartsData?.ler_code_id,
      wastege_value: vehiclePartsData?.wastege_value,
      description: vehiclePartsData?.description,
    };

    actionAddDepollutionOpration(data)
      .then((response) => {
        toast.success(response.data.message);
        setBodyWasteModal(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleVehicleVinForm = (e) => {
    e.preventDefault();
    setLoading(true);
    const updateVehicleFrame = (vinValue) => {
      setVehicleData((prev) => {
        if (!prev) prev = {};
        return {
          ...prev,
          vehicle_frame: vinValue || prev.vehicle_frame || "",
        };
      });
    };

    if (AllvehicleSerachData?.serach_vehicle_id === 2) {
      let data = {
        country: AllvehicleSerachData.country,
        plate: AllvehicleSerachData.plate,
        language: "EN",
      };
      getVehiclePlateAllist(data)
        .then((response) => {
          updateVehicleFrame(response?.data?.data?.vin);
          setVehiclePlateData(response.data.data.vehicles_decoded);
          setSerachModal(true);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      let data = {
        vin: AllvehicleSerachData.vin,
        language: "EN",
      };
      getVehicleVinAllist(data)
        .then((response) => {
          updateVehicleFrame(response?.data?.data?.vin);
          setVehicleVinData(response.data.data.vehicles_decoded);
          setSerachModal(true);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    if (vehicleProcessList?.vin_number) {
      let data = {
        vin: vehicleProcessList?.vin_number,
        language: "EN",
      };
      getVehicleVinAllist(data)
        .then((response) => {
          setVehicleVinData(response.data.data.vehicles_decoded);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [vehicleProcessList?.vin_number]);

  const updateFilterVinData = vehicleVinData?.cars_etai?.filter(
    (data) =>
      data.vehicle_type_model_id_catalog ===
      SelectedVehicleData?.vehicle_type_model_id_catalog
  );

  const filteredVehicleVinData = vehicleVinData?.cars_etai?.filter((data) =>
    [
      data?.vehicle_type_description,
      data?.vehicle_model_fromYear,
      data?.vehicle_type_model,
    ].some((field) =>
      field?.toString().toLowerCase().includes(serach.toLowerCase())
    )
  );

  const filteredVehiclePlateData = vehiclePlateData?.cars_etai?.filter((data) =>
    [
      data?.vehicle_type_description,
      data?.vehicle_model_fromYear,
      data?.vehicle_type_model,
    ].some((field) =>
      field?.toString().toLowerCase().includes(serach.toLowerCase())
    )
  );

  const filteredVehicleVinTecDoc = vehicleVinData?.cars_tecdoc?.filter((data) =>
    [
      data?.vehicle_type_description,
      data?.vehicle_model_fromYear,
      data?.vehicle_type_model,
    ].some((field) =>
      field?.toString().toLowerCase().includes(serach.toLowerCase())
    )
  );

  const filteredVehiclePlateTecDoc = vehiclePlateData?.cars_tecdoc?.filter(
    (data) =>
      [
        data?.vehicle_type_description,
        data?.vehicle_model_fromYear,
        data?.vehicle_type_model,
      ].some((field) =>
        field?.toString().toLowerCase().includes(serach.toLowerCase())
      )
  );

  return (
    <div>
      <div className="row">
        <div className="col-md-12">
          <div className="card card-primary">
            {!vehicleProcessList?.uuid && (
              <div className="row">
                <Form method={`post`} onSubmit={handleVehicleVinForm}>
                  <div className="vehicle-owner-form">
                    <div className="row mt-3 justify-content-start align-items-center">
                      <div className="col-md-3">
                        <FormGroup>
                          <Label className="col-form-label">
                            {t("search_vehicle_by")}
                          </Label>
                          <div className="col-xl-12">
                            <div className="input-div">
                              <Select
                                className="my-select-v"
                                options={VehicleSerachType}
                                getOptionLabel={(o) => t(o.labelKey)}
                                value={VehicleSerachType.find(
                                  (option) =>
                                    option.value ===
                                    AllvehicleSerachData.serach_vehicle_id
                                )}
                                onChange={(selectedOption) =>
                                  setAllVehicleSerachData({
                                    ...AllvehicleSerachData,
                                    serach_vehicle_id: selectedOption.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                        </FormGroup>
                      </div>

                      {AllvehicleSerachData.serach_vehicle_id === 2 ? (
                        <>
                          <div className="col-md-3">
                            <FormGroup>
                              <Label className="col-form-label">
                                {AllvehicleSerachData.serach_vehicle_id === 2
                                  ? t("plate_number")
                                  : t("vin_number")}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control"
                                    type="text"
                                    value={AllvehicleSerachData.plate}
                                    onChange={(e) => {
                                      setAllVehicleSerachData({
                                        ...AllvehicleSerachData,
                                        plate: e.target.value,
                                      });
                                    }}
                                    name={`plate`}
                                    maxLength={100}
                                    placeholder={t("enter_number")}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>
                        </>
                      ) : (
                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label">
                              {AllvehicleSerachData.serach_vehicle_id === 2
                                ? t("plate_number")
                                : t("vin_number")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control"
                                  type="text"
                                  value={AllvehicleSerachData.vin}
                                  onChange={(e) => {
                                    setAllVehicleSerachData((prev) => ({
                                      ...prev,
                                      vin: e.target.value || "",
                                    }));
                                  }}
                                  name={`vin`}
                                  maxLength={100}
                                  placeholder={t("enter_number")}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>
                      )}

                      {AllvehicleSerachData.serach_vehicle_id === 2 && (
                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label">
                              {t("country")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={countryAllData}
                                  placeholder={t("select_country")}
                                  value={countryAllData.find(
                                    (option) =>
                                      option.value ===
                                      AllvehicleSerachData.country
                                  )}
                                  onChange={(selectedOption) =>
                                    setAllVehicleSerachData({
                                      ...AllvehicleSerachData,
                                      country: selectedOption.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>
                      )}

                      <div className="col-md-3 vehicleSearch">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={loading}
                        >
                          {loading ? t("searching_dots") : t("search")}
                        </button>
                      </div>
                    </div>
                  </div>
                  {loading && (
                    <div
                      className="d-flex justify-content-center align-items-center position-fixed top-0 bottom-0 start-0 end-0 z-3"
                      style={{ zIndex: "99", backgroundColor: "#ffffffc2" }}
                    >
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  )}
                </Form>
              </div>
            )}
            <Form method={`post`} onSubmit={handleVehicleForm}>
              <div className="vehicle-owner-form">
                <div className="card-body">
                  {updateFilterVinData?.length > 0 && (
                    <div
                      className="col-md-12 vehicleSearch"
                      style={{ display: "flex", justifyContent: "end" }}
                    >
                      <button
                        type="button"
                        className="btn btn-primary"
                        disabled={loading}
                        onClick={handleViewOpen}
                      >
                        <i className="bi bi-car-front"></i>{" "}
                        {loading ? "Searching..." : "View"}
                      </button>
                    </div>
                  )}
                  <div className="row justify-content-start">
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          {t("select_vehicle_type")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <Select
                              className="my-select-v"
                              options={VehicleTypeList}
                              value={selectedVehicle}
                              onChange={handleVehicleChange}
                              isSearchable={true}
                              placeholder={t("select_vehicle_type")}
                            />
                            {errors.vehicle_type && (
                              <span className="input-error">
                                {errors.vehicle_type}
                              </span>
                            )}
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          {t("select_vehicle_year")}
                        </Label>

                        <div className="col-xl-12">
                          <div className="input-div">
                            <Select
                              className="my-select-v"
                              options={VehicleYearList}
                              value={VehicleYearList.find(
                                (item) =>
                                  item.value == vehicleData.vehicle_year_id
                              )}
                              onChange={(selectedOption) => {
                                const selectedYear = selectedOption
                                  ? selectedOption.value
                                  : null;
                                const inRange =
                                  selectedYear &&
                                  selectedYear >= vehicleData?.initial_year &&
                                  selectedYear <= vehicleData?.year_final;

                                setVehicleData((prev) => ({
                                  ...prev,
                                  vehicle_year_id: selectedYear,
                                  make_id: inRange ? prev.make_id : null,
                                  vehicle_model_id: inRange
                                    ? prev.vehicle_model_id
                                    : null,
                                  variants_id: inRange
                                    ? prev.variants_id
                                    : null,
                                  vehicle_make_name: inRange
                                    ? prev.vehicle_make_name
                                    : "",
                                  vehicle_modal_name: inRange
                                    ? prev.vehicle_modal_name
                                    : "",
                                  vehicle_variants_name: inRange
                                    ? prev.vehicle_variants_name
                                    : "",
                                }));

                                if (!inRange) {
                                  setVehicleMakeList([]);
                                  setVehicleModalList([]);
                                  setVehicleVariantList([]);
                                  setInputSelctedMakeValue("");
                                  setInputSelctedModalValue("");
                                  setInputSelctedVariantValue("");
                                }
                              }}
                              placeholder={t("select_vehicle_year")}
                              onInputChange={handleInputSelectedChangeYearList}
                              inputSelctedValue={inputSelctedeYearValue}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          {t("select_vehicle_make")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <Select
                              className="my-select-v"
                              options={VehicleMakeList}
                              value={
                                VehicleMakeList.find(
                                  (item) => item.value == vehicleData.make_id
                                ) || null
                              }
                              onChange={(selectedOption) => {
                                setVehicleData((prev) => ({
                                  ...prev,
                                  make_id: selectedOption
                                    ? selectedOption.value
                                    : "",
                                  vehicle_make_name: selectedOption
                                    ? selectedOption.label
                                    : "",

                                  vehicle_model_id: "",
                                  variants_id: "",
                                  vehicle_modal_name: "",
                                  vehicle_variants_name: "",
                                }));

                                setVehicleModalList([]);
                                setVehicleVariantList([]);

                                setInputSelctedModalValue("");
                                setInputSelctedVariantValue("");
                              }}
                              inputSelctedValue={inputSelctedeMakeValue}
                              onInputChange={(value, { action }) => {
                                if (action === "input-change") {
                                  handleInputSelectedChangeMakeList(value);
                                }
                              }}
                              placeholder={t("select_vehicle_make")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          {t("select_vehicle_model")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <Select
                              className="my-select-v"
                              options={VehicleModalList}
                              value={
                                VehicleModalList.find(
                                  (item) =>
                                    item.value == vehicleData.vehicle_model_id
                                ) || null
                              }
                              onChange={(selectedOption) => {
                                setVehicleData((prev) => ({
                                  ...prev,
                                  vehicle_model_id: selectedOption
                                    ? selectedOption.value
                                    : "",
                                  vehicle_modal_name: selectedOption
                                    ? selectedOption.label
                                    : "",
                                  variants_id: "",
                                  vehicle_variants_name: "",
                                }));

                                setVehicleVariantList([]);
                                setInputSelctedVariantValue("");
                              }}
                              onInputChange={(value, { action }) => {
                                if (action === "input-change") {
                                  handleInputSelectedChangeModalList(value);
                                }
                              }}
                              inputSelctedValue={inputSelctedeModalValue}
                              placeholder={t("select_vehicle_model")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label">
                          {t("select_vehicle_variants")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <Select
                              className="my-select-v"
                              options={VehicleVariantList}
                              value={
                                VehicleVariantList.find(
                                  (item) =>
                                    item.value ===
                                    Number(vehicleData.variants_id)
                                ) || null
                              }
                              onChange={(selectedOption) =>
                                setVehicleData({
                                  ...vehicleData,
                                  variants_id: selectedOption
                                    ? selectedOption.value
                                    : "",
                                  vehicle_variants_name: selectedOption
                                    ? selectedOption.label
                                    : "",
                                  initial_year: selectedOption
                                    ? selectedOption.initial_year
                                    : "",
                                  year_final:
                                    Number(selectedOption?.year_final) > 0
                                      ? selectedOption.year_final
                                      : "2025",
                                })
                              }
                              onInputChange={(value, { action }) => {
                                if (action === "input-change") {
                                  handleInputSelectedChangeVariantList(value);
                                }
                              }}
                              inputSelctedValue={inputSelctededVariantValue}
                              placeholder={t("select_vehicle_variant")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3 d-none">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my form-label form-label d-none">
                          {t("select_vehicle_year_etai")}
                        </Label>

                        <div className="col-xl-12 d-none">
                          <div className="input-div">
                            <Select
                              className="my-select-v"
                              options={VehicleYearList}
                              value={
                                VehicleYearList.find(
                                  (item) =>
                                    item.value == vehicleData.vehicle_year_etai
                                ) || null
                              }
                              onChange={(selectedOption) => {
                                setVehicleData((prev) => ({
                                  ...prev,
                                  vehicle_year_etai: selectedOption
                                    ? selectedOption.value
                                    : "",
                                  vehicle_make_etai: "",
                                  vehicle_model_etai: "",
                                  vehicle_variants_etai: "",
                                }));
                                setVehicleMakeETAIList([]);
                                setVehicleModalETAIList([]);
                                setVehicleVariantETAIList([]);
                              }}
                              placeholder={t("select_vehicle_year_etai")}
                              onInputChange={
                                handleInputSelectedChangeYearEtaiList
                              }
                              inputSelctedValue={inputSelctedeYearETAIValue}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("registration_plate")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control"
                              type="text"
                              value={vehicleData.registration_plate}
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  registration_plate: e.target.value,
                                });
                              }}
                              name={`registration_plate`}
                              maxLength={100}
                              placeholder={t("registration_plate")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("registration")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control"
                              type="text"
                              value={vehicleData.registration}
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  registration: e.target.value,
                                });
                              }}
                              name={`registration`}
                              maxLength={50}
                              placeholder={t("registration")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("process_start_date")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              type="date"
                              id="vehicle_process_start_date"
                              className="form-control"
                              value={
                                vehicleData.vehicle_process_start_date ||
                                new Date().toISOString().split("T")[0]
                              }
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  vehicle_process_start_date: e.target.value,
                                });
                              }}
                              disabled={!!vehicleProcessList?.uuid}
                              placeholder={t("process_start_date")}
                            />
                          </div>
                          {errors.vehicle_process_start_date && (
                            <span className="input-error">
                              {errors.vehicle_process_start_date}
                            </span>
                          )}
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("process_end_date")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              type="date"
                              id="vehicle_process_end_date"
                              className="form-control"
                              value={
                                vehicleData.vehicle_process_end_date ||
                                new Date().toISOString().split("T")[0]
                              }
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  vehicle_process_end_date: e.target.value,
                                });
                              }}
                              disabled={!!vehicleProcessList?.uuid}
                              placeholder={t("process_end_date")}
                            />
                          </div>
                          {errors.vehicle_process_end_date && (
                            <span className="input-error">
                              {errors.vehicle_process_end_date}
                            </span>
                          )}
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("vehicle_vin")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control"
                              type="text"
                              value={vehicleData.vehicle_frame}
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  vehicle_frame: e.target.value,
                                });
                              }}
                              name={`vehicle_frame`}
                              maxLength={100}
                              placeholder={t("vehicle_vin")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("certificate_number")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control"
                              type="text"
                              value={vehicleData.certificate_number}
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  certificate_number: e.target.value,
                                });
                              }}
                              name={`certificate_number`}
                              maxLength={100}
                              placeholder={t("certificate_number")}
                              // disabled={!!vehicleData?.certificate_number}
                              disabled={certificateDetails?.certificate_id}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("vehicle_park")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <Select
                              className="my-select-v"
                              options={ShelfList}
                              onInputChange={(inputValue) => {
                                fetchShelfList(inputValue);
                              }}
                              value={
                                vehicleData.vehicle_park
                                  ? {
                                      value: vehicleData.vehicle_park,
                                      label: vehicleData.vehicle_park_name,
                                    }
                                  : null
                              }
                              onChange={(selectedOption) =>
                                setVehicleData({
                                  ...vehicleData,
                                  vehicle_park: selectedOption.value,
                                  vehicle_park_name: selectedOption.label,
                                })
                              }
                              placeholder={t("select_vehicle_park")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">{t("shelf")}</Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <Select
                              className="my-select-v"
                              options={vehicleShelfList}
                              value={vehicleShelfList.find(
                                (option) =>
                                  option.value === Number(vehicleData.shelf_id)
                              )}
                              onChange={(selectedOption) =>
                                setVehicleData({
                                  ...vehicleData,
                                  shelf_id: selectedOption.value,
                                })
                              }
                              placeholder={t("select_shelf")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">{t("brand")}</Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control"
                              type="text"
                              value={vehicleData.vehicle_brand}
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  vehicle_brand: e.target.value,
                                });
                              }}
                              name={`vehicle_brand`}
                              maxLength={30}
                              placeholder={t("brand")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("booklet_model")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control"
                              type="text"
                              value={vehicleData.vehicle_booklet_model}
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  vehicle_booklet_model: e.target.value,
                                });
                              }}
                              name={`vehicle_booklet_model`}
                              maxLength={100}
                              placeholder={t("booklet_model")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("vehicle_model")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control"
                              type="text"
                              value={vehicleData.vehicle_model}
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  vehicle_model: e.target.value,
                                });
                              }}
                              name={`vehicle_model`}
                              maxLength={30}
                              placeholder={t("vehicle_model")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("vehicle_tare")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control"
                              type="text"
                              value={vehicleData.vehicle_tare}
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  vehicle_tare: e.target.value,
                                });
                              }}
                              name={`vehicle_tare`}
                              maxLength={100}
                              placeholder={t("vehicle_tare")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("vehicle_category")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            {/* <Select
                              className="my-select-v"
                              options={VehicleCategoryList}
                              value={selectedCategory}
                              onChange={(selectedOption) =>
                                setVehicleData({
                                  ...vehicleData,
                                  vehicle_category: selectedOption
                                    ? selectedOption.value
                                    : "",
                                })
                              }
                              placeholder={t("select_vehicle_category")}
                            /> */}

                            <Select
                              className="my-select-v"
                              options={VehicleCategoryList}
                              value={selectedVehicleCategory}
                              onChange={handleVehicleCategoryChange}
                              isSearchable={true}
                              placeholder={t("select_vehicle_category")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("vehicle_year")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control"
                              type="number"
                              value={vehicleData.vehicle_year}
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  vehicle_year: e.target.value,
                                });
                              }}
                              name={`vehicle_year`}
                              maxLength={100}
                              placeholder={t("vehicle_year")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("vehicle_kms")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control"
                              type="number"
                              value={vehicleData.vehicle_kms}
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  vehicle_kms: e.target.value,
                                });
                              }}
                              name={`vehicle_kms`}
                              maxLength={100}
                              placeholder={t("vehicle_kms")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3">
                      <FormGroup className="mt-3">
                        <Label>{t("vehicle_doors")}</Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <Select
                              options={vehicleDoorList}
                              value={vehicleDoorList.find(
                                (option) =>
                                  option.value ===
                                  Number(vehicleData.vehicle_doors)
                              )}
                              onChange={(selectedOption) =>
                                setVehicleData({
                                  ...vehicleData,
                                  vehicle_doors: selectedOption.value,
                                })
                              }
                              placeholder={t("select_vehicle_doors")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("vehicle_approval")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control"
                              type="text"
                              value={vehicleData.vehicle_approval}
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  vehicle_approval: e.target.value,
                                });
                              }}
                              name={`vehicle_approval`}
                              maxLength={100}
                              placeholder={t("vehicle_approval")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("vehicle_total_gross_weight")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control"
                              type="number"
                              value={vehicleData.vehicle_total_gross_weight}
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  vehicle_total_gross_weight: e.target.value,
                                });
                              }}
                              name={`vehicle_total_gross_weight`}
                              maxLength={100}
                              placeholder={t("vehicle_total_gross_weight")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("vehicle_fuel")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            {/* <Select
                              className="my-select-v"
                              options={VehicleFuelList}
                              value={selectedFuel}
                              onChange={(selectedOption) =>
                                setVehicleData({
                                  ...vehicleData,
                                  vehicle_fuel: selectedOption
                                    ? selectedOption.value
                                    : "",
                                })
                              }
                              placeholder={t("select_vehicle_fuel")}
                            /> */}

                            <Select
                              className="my-select-v"
                              options={VehicleFuelList}
                              value={selectedVehicleFuel}
                              onChange={handleVehicleFuelChange}
                              isSearchable={true}
                              placeholder={t("select_vehicle_fuel")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("vehicle_parts")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control"
                              type="number"
                              value={vehicleData.vehicle_parts}
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  vehicle_parts: e.target.value,
                                });
                              }}
                              name={`vehicle_parts`}
                              maxLength={100}
                              placeholder={t("vehicle_parts")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("vehicle_color")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control"
                              type="text"
                              value={vehicleData.vehicle_color}
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  vehicle_color: e.target.value,
                                });
                              }}
                              name={`vehicle_color`}
                              maxLength={100}
                              placeholder={t("vehicle_color")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("vehicle_eei")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control"
                              type="number"
                              value={vehicleData.vehicle_eei}
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  vehicle_eei: e.target.value,
                                });
                              }}
                              name={`vehicle_eei`}
                              maxLength={100}
                              placeholder={t("vehicle_eei")}
                            />
                          </div>
                          {errors.vehicle_eei && (
                            <span className="input-error">
                              {errors.vehicle_eei}
                            </span>
                          )}
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("vehicle_internal_ref")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control"
                              type="text"
                              value={vehicleData.vehicle_internl_ref}
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  vehicle_internl_ref: e.target.value,
                                });
                              }}
                              name={`vehicle_internl_ref`}
                              maxLength={100}
                              placeholder={t("vehicle_internal_ref")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("vehicle_external_ref")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control"
                              type="text"
                              value={vehicleData.vehicle_external_ref}
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  vehicle_external_ref: e.target.value,
                                });
                              }}
                              name={`vehicle_external_ref`}
                              maxLength={100}
                              placeholder={t("vehicle_external_ref")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("vehicle_exp_value")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control"
                              type="number"
                              value={vehicleData.vehicle_exp_value}
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  vehicle_exp_value: e.target.value,
                                });
                              }}
                              name={`vehicle_exp_value`}
                              maxLength={100}
                              placeholder={t("vehicle_exp_value")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("vehicle_provenance")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control"
                              type="text"
                              value={vehicleData.vehicle_provenance}
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  vehicle_provenance: e.target.value,
                                });
                              }}
                              name={`vehicle_provenance`}
                              maxLength={100}
                              placeholder={t("vehicle_provenance")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <div className="col-md-12">
                        <FormGroup>
                          <Label className="col-form-label ml-2 Label-my form-label form-label">
                            {t("select_vehicle_engine")}
                          </Label>

                          <div className="col-xl-12">
                            <div className="input-div">
                              <Select
                                className="my-select-v"
                                options={VehicleEngineList}
                                value={VehicleEngineList.find(
                                  (item) =>
                                    item.value == vehicleData.vehicle_engine
                                )}
                                onChange={(selectedOption) => {
                                  setVehicleData({
                                    ...vehicleData,
                                    vehicle_engine: selectedOption
                                      ? selectedOption.value
                                      : "",
                                  });
                                  setVehicleEngineData(selectedOption);
                                }}
                                isSearchable={true}
                                onInputChange={
                                  handleInputSelectedChangeEngineList
                                }
                                inputSelctedValue={inputSelctededEngineValue}
                                placeholder={t("select_vehicle_engine")}
                              />
                            </div>
                          </div>
                        </FormGroup>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("motorization")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control"
                              type="text"
                              value={vehicleData.vehicle_motorization}
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  vehicle_motorization: e.target.value,
                                });
                              }}
                              name={`vehicle_motorization`}
                              maxLength={100}
                              placeholder={t("motorization")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">{t("Ccm3")}</Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control"
                              type="text"
                              value={vehicleData.ccm3}
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  ccm3: e.target.value,
                                });
                              }}
                              name={`ccm3`}
                              maxLength={100}
                              placeholder={t("ccm3")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("power_Kw")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control"
                              type="text"
                              value={vehicleData.power_kw}
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  power_kw: e.target.value,
                                });
                              }}
                              name={`power_kw`}
                              maxLength={100}
                              placeholder={t("power_Kw")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">{t("HP")}</Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control"
                              type="text"
                              value={vehicleData.hp}
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  hp: e.target.value,
                                });
                              }}
                              name={`hp`}
                              maxLength={100}
                              placeholder={t("HP")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("vehicle_cyllinder")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control"
                              type="number"
                              value={vehicleData.vehicle_cyllinder || ""}
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  vehicle_cyllinder: e.target.value,
                                });
                              }}
                              name={`vehicle_cyllinder`}
                              maxLength={100}
                              placeholder={t("vehicle_cyllinder")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3">
                      <FormGroup>
                        <Label>{t("inventory_status")}</Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <Select
                              options={inventoryList}
                              getOptionLabel={(o) => tConstStatic(o.label)}
                              value={
                                inventoryList.find(
                                  (option) =>
                                    option.value ===
                                    vehicleData.inventory_status
                                ) || { value: 1, label: "In Stock" }
                              }
                              onChange={(selectedOption) =>
                                setVehicleData({
                                  ...vehicleData,
                                  inventory_status: selectedOption.value,
                                })
                              }
                              placeholder={t("select_inventory_status")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3">
                      <FormGroup>
                        <Label>{t("depolution_status")}</Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <Select
                              options={deplllutionList}
                              getOptionLabel={(o) => tConstStatic(o.label)}
                              value={
                                deplllutionList.find(
                                  (option) =>
                                    option.value ===
                                    vehicleData.deplllution_status
                                ) || { value: 1, label: "Pending" }
                              }
                              onChange={(selectedOption) =>
                                setVehicleData({
                                  ...vehicleData,
                                  deplllution_status: selectedOption.value,
                                })
                              }
                              placeholder={t("select_depolution_status")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3">
                      <FormGroup>
                        <Label>{t("dismental_status")}</Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <Select
                              options={dismentalList}
                              getOptionLabel={(o) => tConstStatic(o.label)}
                              value={
                                dismentalList.find(
                                  (option) =>
                                    option.value ===
                                    vehicleData.dismental_status
                                ) || { value: 1, label: "Pending" }
                              }
                              onChange={(selectedOption) =>
                                setVehicleData({
                                  ...vehicleData,
                                  dismental_status: selectedOption.value,
                                })
                              }
                              placeholder={t("select_dismental_status")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3">
                      <FormGroup>
                        <Label>{t("state_parking")}</Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <Select
                              options={stateParkingList}
                              getOptionLabel={(o) => tConstStatic(o.label)}
                              value={stateParkingList.find(
                                (option) =>
                                  option.value ===
                                  Number(vehicleData.state_parking)
                              )}
                              onChange={(selectedOption) =>
                                setVehicleData({
                                  ...vehicleData,
                                  state_parking: selectedOption.value,
                                })
                              }
                              placeholder={t("select_state_parking")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3">
                      <FormGroup className="mt-2">
                        <Label className="col-form-label">
                          {t("steering_wheel_side")}
                        </Label>
                        <div
                          className="input-div radiobtns mt-12 gap-3"
                          style={{ marginLeft: "11px" }}
                        >
                          <div className="form-check form-check-radio">
                            <input
                              className="form-check-input custom-radio"
                              type="radio"
                              id="left"
                              name="steering_wheel_side"
                              value="1"
                              checked={vehicleData.steering_wheel_side === "1"}
                              onChange={(e) =>
                                setVehicleData({
                                  ...vehicleData,
                                  steering_wheel_side: e.target.value,
                                })
                              }
                            />
                            <Label
                              className="form-check-label form-label"
                              htmlFor="left"
                              style={{ marginLeft: "-3px" }}
                            >
                              {t("left")}
                            </Label>
                          </div>

                          <div className="form-check form-check-radio">
                            <input
                              className="form-check-input custom-radio"
                              type="radio"
                              id="right"
                              name="steering_wheel_side"
                              value="2"
                              checked={vehicleData.steering_wheel_side === "2"}
                              onChange={(e) =>
                                setVehicleData({
                                  ...vehicleData,
                                  steering_wheel_side: e.target.value,
                                })
                              }
                            />
                            <Label
                              className="form-check-label form-label"
                              htmlFor="right"
                              style={{ marginLeft: "-3px" }}
                            >
                              {t("right")}
                            </Label>
                          </div>

                          <div className="form-check form-check-radio">
                            <input
                              className="form-check-input custom-radio"
                              type="radio"
                              id="na"
                              name="steering_wheel_side"
                              value="0"
                              checked={vehicleData.steering_wheel_side === "0"}
                              onChange={(e) =>
                                setVehicleData({
                                  ...vehicleData,
                                  steering_wheel_side: e.target.value,
                                })
                              }
                            />
                            <Label
                              className="form-check-label form-label"
                              htmlFor="na"
                              style={{ marginLeft: "-3px" }}
                            >
                              {t("not_applicable")}
                            </Label>
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("neutralization_date")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              type="date"
                              id="neutralization_date"
                              className="form-control"
                              value={
                                vehicleData.neutralization_date ||
                                new Date().toISOString().split("T")[0]
                              }
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  neutralization_date: e.target.value,
                                });
                              }}
                              placeholder={t("neutralization_date")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("decontamination_date")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              type="date"
                              id="decontamination_date"
                              className="form-control"
                              value={
                                vehicleData.decontamination_date ||
                                new Date().toISOString().split("T")[0]
                              }
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  decontamination_date: e.target.value,
                                });
                              }}
                              placeholder={t("decontamination_date")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("vehicle_arrival_date")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              type="date"
                              id="vehicle_arrival_date"
                              className="form-control"
                              value={
                                vehicleData.vehicle_arrival_date ||
                                new Date().toISOString().split("T")[0]
                              }
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  vehicle_arrival_date: e.target.value,
                                });
                              }}
                              placeholder={t("vehicle_arrival_date")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {t("sented_to_waste_date")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              type="date"
                              id="sented_to_waste_date"
                              className="form-control"
                              value={
                                vehicleData.sented_to_waste_date ||
                                new Date().toISOString().split("T")[0]
                              }
                              onChange={(e) => {
                                setVehicleData({
                                  ...vehicleData,
                                  sented_to_waste_date: e.target.value,
                                });
                              }}
                              placeholder={t("sented_to_waste_date")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                  </div>
                  <div className="back-footer">
                    <div className="row align-items-center">
                      <div className="col-4">
                        <button
                          type="button"
                          className="next-button btn btn-secondary"
                          onClick={() => navigate("/vehicle-process")}
                        >
                          <i className="bi bi-arrow-left"></i> {t("cancel")}
                        </button>
                      </div>
                      <div className="col-4 text-center">
                        <small style={{ color: "#9ca3af" }}>
                          {t("step_x_of_n", { current: 1, total: 6 })}
                        </small>
                      </div>
                      <div className="col-4 text-end">
                        {btnLoader === true ? (
                          <button type="submit" className="btn btn-primary">
                            {t("loading")}
                          </button>
                        ) : (
                          <button type="submit" className="btn btn-primary">
                            {t("save_and_continue")}
                            <i className="bi bi-arrow-right ms-1"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-footer"></div>
            </Form>
          </div>
        </div>
      </div>

      <Modal className="modal-xl" isOpen={serachModal}>
        <ModalHeader>
          {t("please_select_vehicle_info")}
          <button
            type="button"
            className="btn-closes-1"
            onClick={() => setSerachModal(false)}
          >
            <i className="bi bi-x"></i>
          </button>
        </ModalHeader>
        <ModalBody>
          <div className="row justify-content-start">
            <div className="row mb-3">
              <div className="col-lg-6">
                <div className="col-xl-12">
                  <input
                    className="form-control"
                    type="text"
                    value={serach}
                    onChange={(e) => setSerach(e.target.value)}
                    // maxLength={50}
                    placeholder={t("search_like_description")}
                  />
                </div>
              </div>
            </div>
            <div className="card-body vehicleparts-table">
              <div className="vehicleparts-table-inner vehicle-serach d-none">
                <div className="vehicleparts-table-modal">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th></th>
                        <th>{t("description")}</th>
                        <th>{t("images")}</th>
                        <th>{t("year")}</th>
                        <th>{t("model")}</th>
                        <th>{t("range")}</th>
                        <th>{t("body_type")}</th>
                        <th>{t("CCM")}</th>
                        <th>{t("CYL")}</th>
                        <th>{t("Doors")}</th>
                        <th>{t("box_type")}</th>
                        <th>{t("manufacturer")}</th>
                        <th>{t("vehicle_type")}</th>
                        <th>{t("oil_capacity")}</th>
                      </tr>
                    </thead>

                    {AllvehicleSerachData.serach_vehicle_id === 1 ? (
                      <tbody>
                        {filteredVehicleVinData?.length > 0 ? (
                          filteredVehicleVinData?.map((data, index) => {
                            const optionValue =
                              data?.vehicle_type_model_id_external ||
                              `option-${index}`;
                            return (
                              <tr key={index}>
                                <td>
                                  {/* <button
                                    type="button"
                                    className={`btn ${
                                      selectedOption === optionValue
                                        ? "btn-success"
                                        : "btn-primary"
                                    }`}
                                  >
                                    Select
                                  </button> */}

                                  <input
                                    type="radio"
                                    value={optionValue}
                                    checked={selectedOption === optionValue}
                                    onChange={(e) =>
                                      handleOptionChange(e, data)
                                    }
                                  />
                                </td>
                                <td>{data?.vehicle_type_description}</td>
                                <td>
                                  <a
                                    className="eye-box1"
                                    href={data?.vehicle_model_image}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="View vehicle model image"
                                  >
                                    <i className="bi bi-eye"></i>
                                  </a>
                                </td>
                                <td>{data?.vehicle_model_fromYear}</td>
                                <td>{data?.vehicle_type_model}</td>
                                <td>{data?.vehicle_model_range}</td>
                                <td>{data?.vehicle_type_bodyType}</td>
                                <td>{data?.vehicle_type_ccm}</td>
                                <td>{data?.vehicle_type_cyl}</td>
                                <td>{data?.vehicle_type_doors}</td>
                                <td>{data?.vehicle_type_gearboxType}</td>
                                <td>{data?.vehicle_type_manufacter}</td>
                                <td>{data?.vehicle_type_vehicleType}</td>
                                <td>{data?.vehicle_type_oilCapacity}</td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={14} className="text-center">
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    ) : (
                      <tbody>
                        {filteredVehiclePlateData?.map((data, index) => {
                          const optionValue =
                            data?.vehicle_type_model_id_catalog ||
                            `option-${index}`;

                          return (
                            <tr key={index}>
                              <td>
                                <input
                                  type="radio"
                                  value={optionValue}
                                  checked={selectedOption === optionValue}
                                  onChange={(e) => handleOptionChange(e, data)}
                                />
                              </td>
                              {/* <td>
                                <button
                                  type="button"
                                  className={`btn ${
                                    selectedOption === optionValue
                                      ? "btn-success"
                                      : "btn-primary"
                                  }`}
                                  onClick={(e) => handleOptionChange(e, data)}
                                >
                                  Select
                                </button>
                              </td> */}
                              <td>{data?.vehicle_type_description}</td>
                              <td>
                                <td>
                                  <a
                                    className="eye-box1"
                                    href={data?.vehicle_make_image}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="View vehicle model image"
                                  >
                                    <i className="bi bi-eye"></i>
                                  </a>
                                </td>
                              </td>
                              <td>{data?.vehicle_model_fromYear}</td>
                              <td>{data?.vehicle_type_model}</td>
                              <td>{data?.vehicle_model_range}</td>
                              <td>{data?.vehicle_type_bodyType}</td>
                              <td>{data?.vehicle_type_ccm}</td>
                              <td>{data?.vehicle_type_cyl}</td>
                              <td>{data?.vehicle_type_doors}</td>
                              <td>{data?.vehicle_type_gearboxType}</td>
                              <td>{data?.vehicle_type_manufacter}</td>
                              <td>{data?.vehicle_type_vehicleType}</td>
                              <td>{data?.vehicle_type_oilCapacity}</td>
                            </tr>
                          );
                        })}
                        {vehiclePlateData?.cars_etai?.filter((data) =>
                          data?.vehicle_type_description
                            ?.toLowerCase()
                            .includes(searchQuery.toLowerCase())
                        ).length === 0 && (
                          <tr>
                            <td colSpan={14} className="text-center">
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    )}
                  </table>
                </div>
              </div>
              <h4 style={{ marginTop: "20px" }}>Cars TecDoc Details</h4>

              <div
                className="vehicleparts-table-inner vehicle-serach"
                style={{ marginTop: "20px" }}
              >
                <div className="vehicleparts-table-modal">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th></th>
                        <th>{t("description")}</th>
                        <th>{t("model")}</th>
                        <th>{t("body_type")}</th>
                        <th>{t("CCM")}</th>
                        <th>{t("CYL")}</th>
                        <th>{t("Doors")}</th>
                        <th>{t("manufacturer")}</th>
                      </tr>
                    </thead>

                    {AllvehicleSerachData.serach_vehicle_id === 1 ? (
                      <tbody>
                        {filteredVehicleVinTecDoc?.map((data, index) => {
                          const optionValue =
                            data?.vehicle_type_model_id_catalog ||
                            `option-${index}`;

                          return (
                            <tr key={index}>
                              <td>
                                <input
                                  type="radio"
                                  value={optionValue}
                                  checked={selectedOptionCarTec === optionValue}
                                  onChange={(e) =>
                                    handleOptionChangeCarsTec(e, data)
                                  }
                                />
                              </td>
                              <td>{data?.vehicle_type_description}</td>

                              <td>{data?.vehicle_type_model}</td>
                              <td>{data?.vehicle_type_bodyType}</td>
                              <td>{data?.vehicle_type_ccm}</td>
                              <td>{data?.vehicle_type_cyl}</td>
                              <td>{data?.vehicle_type_doors}</td>
                              <td>{data?.vehicle_type_manufacter}</td>
                            </tr>
                          );
                        })}
                        {vehicleVinData?.cars_tecdoc?.filter((data) =>
                          data?.vehicle_type_description
                            ?.toLowerCase()
                            .includes(searchQuery.toLowerCase())
                        ).length === 0 && (
                          <tr>
                            <td colSpan={14} className="text-center">
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    ) : (
                      <tbody>
                        {filteredVehiclePlateTecDoc?.map((data, index) => {
                          const optionValue =
                            data?.vehicle_type_model_id_catalog ||
                            `option-${index}`;

                          return (
                            <tr key={index}>
                              <td>
                                <input
                                  type="radio"
                                  value={optionValue}
                                  checked={selectedOptionCarTec === optionValue}
                                  onChange={(e) =>
                                    handleOptionChangeCarsTec(e, data)
                                  }
                                />
                              </td>
                              <td>{data?.vehicle_type_description}</td>
                              <td>{data?.vehicle_model_fromYear}</td>
                              <td>{data?.vehicle_type_model}</td>
                              <td>{data?.vehicle_model_range}</td>
                              <td>{data?.vehicle_type_bodyType}</td>
                              <td>{data?.vehicle_type_ccm}</td>
                              <td>{data?.vehicle_type_cyl}</td>
                            </tr>
                          );
                        })}
                        {vehiclePlateData?.cars_etai?.filter((data) =>
                          data?.vehicle_type_description
                            ?.toLowerCase()
                            .includes(searchQuery.toLowerCase())
                        ).length === 0 && (
                          <tr>
                            <td colSpan={14} className="text-center">
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    )}
                  </table>
                </div>
              </div>
            </div>

            <div
              className="d-flex justify-content-end"
              style={{ padding: "10px" }}
            ></div>
          </div>
        </ModalBody>
        <ModalFooter className="border-0" style={{ marginTop: "-18px" }}>
          <button
            type="button"
            className="btn btn-block btn-payment d-flex align-items-center justify-content-center"
            onClick={handleSelectEtaiDetails}
            disabled={loadingSelect}
            style={{
              width: "auto",
              margin: "auto",
              padding: "5px 12px",
              opacity: loadingSelect ? 0.7 : 1,
              pointerEvents: loadingSelect ? "none" : "auto",
            }}
          >
            {loadingSelect ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading...
              </>
            ) : (
              <>
                Select <i className="bi bi-x-lg ms-2"></i>
              </>
            )}
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={bodyWasteModal}>
        <ModalHeader>Depollution</ModalHeader>
        <Form method={`post`} onSubmit={handleSubmit}>
          <ModalBody>
            <div className="row">
              <div className="col-md-6">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                    {"Select LER Catalog"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-Select"
                        options={LerCatalogList}
                        value={LerCatalogList.find(
                          (item) => item.value == vehiclePartsData.ler_code_id
                        )}
                        onChange={handleSelectLERChange}
                        placeholder={t("select_ler_catalog")}
                        isSearchable={true}
                        onInputChange={handleInputChangeLER}
                        inputValue={inputValueLer}
                        isClearable={true}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>
              {vehiclePartsData?.ler_code_id && (
                <div className="row">
                  <div className="col-md-6">
                    <ul style={{ listStyle: "square", marginBottom: "0" }}>
                      <li>LER Code: {LerCatalogHistoryList?.ler_code}</li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul style={{ listStyle: "square", marginBottom: "0" }}>
                      <li>Unit Type: {LerCatalogHistoryList?.item_weight}</li>
                    </ul>
                  </div>

                  <div className="col-md-6">
                    <ul style={{ listStyle: "square", marginBottom: "0" }}>
                      <li>
                        Unit Value: {LerCatalogHistoryList?.item_weight_unit}
                      </li>
                    </ul>
                  </div>

                  <div className="col-md-6">
                    <ul style={{ listStyle: "square", marginBottom: "0" }}>
                      <li>
                        Old Value: {LerCatalogHistoryList?.old_value ?? 0}
                      </li>
                    </ul>
                  </div>
                </div>
              )}
              <div className="col-md-6">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                    {"Wastege Value"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="number"
                        value={vehiclePartsData.wastege_value}
                        onChange={(e) => {
                          setVehiclePartsData({
                            ...vehiclePartsData,
                            wastege_value: e.target.value,
                          });
                        }}
                        name={`wastege_value`}
                        maxLength={100}
                        placeholder={t("wastage_value")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-12">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                    {"Description"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <textarea
                        className="form-control input-search"
                        type="text"
                        value={vehiclePartsData.description}
                        onChange={(e) => {
                          setVehiclePartsData({
                            ...vehiclePartsData,
                            description: e.target.value,
                          });
                        }}
                        name={`description`}
                        maxLength={100}
                        placeholder={t("description")}
                        rows={3}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-secondary"
              onClick={handleBodyWasteClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              Close <i className="bi bi-x-lg"></i>
            </button>
            <button
              type="submit"
              className="btn btn-block btn-primary"
              style={{ width: "100px", marginTop: "10px" }}
            >
              Submit <i className="bi bi-check2"></i>
            </button>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={viewModal} size="lg">
        <div className="border m-3 p-3">
          <ModalHeader className="p-0 pb-2">Vehicle Details</ModalHeader>

          <ModalBody>
            {updateFilterVinData?.length > 0 ? (
              <>
                <div className="com-md-12">
                  <div className="col-md-12">
                    <table className="fuelTable d-none">
                      {updateFilterVinData?.map((item) => {
                        return (
                          <>
                            <tbody className="row">
                              <tr className="col-md-6">
                                <td>Description</td>
                                <td>:</td>
                                <td>{item?.vehicle_type_description}</td>
                              </tr>
                              <tr className="col-md-6">
                                <td>Year</td>
                                <td>:</td>
                                <td>{item?.vehicle_model_fromYear}</td>
                              </tr>
                              <tr className="col-md-6">
                                <td>Range</td>
                                <td>:</td>
                                <td>{item?.vehicle_model_range}</td>
                              </tr>
                              <tr className="col-md-6">
                                <td>Type</td>
                                <td>:</td>
                                <td>{item?.vehicle_type_vehicleType}</td>
                              </tr>
                              <tr className="col-md-6">
                                <td>Model</td>
                                <td>:</td>
                                <td>{item?.vehicle_type_model}</td>
                              </tr>
                              <tr className="col-md-6">
                                <td>Manufacter</td>
                                <td>:</td>
                                <td>{item?.vehicle_type_manufacter}</td>
                              </tr>
                              <tr className="col-md-6">
                                <td>GgearboxType</td>
                                <td>:</td>
                                <td>{item?.vehicle_type_gearboxType}</td>
                              </tr>

                              <tr className="col-md-6"></tr>
                            </tbody>
                          </>
                        );
                      })}
                    </table>
                  </div>

                  <div className="col-md-12" style={{ marginTop: "43px" }}>
                    <h4>Cars TecDoc Details</h4>
                    {vehicleVinData?.cars_tecdoc?.map((item) => {
                      return (
                        <>
                          <table className="fuelTable">
                            <tbody className="row">
                              <tr className="col-md-6">
                                <td>Description</td>
                                <td>:</td>
                                <td>{item?.vehicle_type_description}</td>
                              </tr>
                              <tr className="col-md-6">
                                <td>Year</td>
                                <td>:</td>
                                <td>{item?.vehicle_model_fromYear}</td>
                              </tr>
                              <tr className="col-md-6">
                                <td>Range</td>
                                <td>:</td>
                                <td>{item?.vehicle_model_range}</td>
                              </tr>
                              <tr className="col-md-6">
                                <td>Type</td>
                                <td>:</td>
                                <td>{item?.vehicle_type_vehicleType}</td>
                              </tr>
                              <tr className="col-md-6">
                                <td>Model</td>
                                <td>:</td>
                                <td>{item?.vehicle_type_model}</td>
                              </tr>
                              <tr className="col-md-6">
                                <td>Manufacter</td>
                                <td>:</td>
                                <td>{item?.vehicle_type_manufacter}</td>
                              </tr>
                              <tr className="col-md-6">
                                <td>GgearboxType</td>
                                <td>:</td>
                                <td>{item?.vehicle_type_gearboxType}</td>
                              </tr>

                              <tr className="col-md-6"></tr>
                            </tbody>
                          </table>
                        </>
                      );
                    })}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="com-md-12">
                  <div className="col-md-12">
                    {/* <h4>Cars ETAI Details</h4> */}
                    <table className="fuelTable d-none">
                      <tbody className="row">
                        <tr className="col-md-6">
                          <td>Description</td>
                          <td>:</td>
                          <td>
                            {SelectedVehicleData?.vehicle_type_description}
                          </td>
                        </tr>
                        <tr className="col-md-6">
                          <td>Year</td>
                          <td>:</td>
                          <td>{SelectedVehicleData?.vehicle_model_fromYear}</td>
                        </tr>
                        <tr className="col-md-6">
                          <td>Range</td>
                          <td>:</td>
                          <td>{SelectedVehicleData?.vehicle_model_range}</td>
                        </tr>
                        <tr className="col-md-6">
                          <td>Type</td>
                          <td>:</td>
                          <td>
                            {SelectedVehicleData?.vehicle_type_vehicleType}
                          </td>
                        </tr>
                        <tr className="col-md-6">
                          <td>Model</td>
                          <td>:</td>
                          <td>{SelectedVehicleData?.vehicle_type_model}</td>
                        </tr>
                        <tr className="col-md-6">
                          <td>Manufacter</td>
                          <td>:</td>
                          <td>
                            {SelectedVehicleData?.vehicle_type_manufacter}
                          </td>
                        </tr>
                        <tr className="col-md-6">
                          <td>GgearboxType</td>
                          <td>:</td>
                          <td>
                            {SelectedVehicleData?.vehicle_type_gearboxType}
                          </td>
                        </tr>

                        <tr className="col-md-6"></tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="col-md-12" style={{ marginTop: "43px" }}>
                    <h4>Cars TecDoc Details</h4>
                    <table className="fuelTable">
                      <tbody className="row">
                        <tr className="col-md-6">
                          <td>Description</td>
                          <td>:</td>
                          <td>
                            {SelectedVehicleData?.vehicle_type_description}
                          </td>
                        </tr>
                        <tr className="col-md-6">
                          <td>Year</td>
                          <td>:</td>
                          <td>{SelectedVehicleData?.vehicle_model_fromYear}</td>
                        </tr>
                        <tr className="col-md-6">
                          <td>Range</td>
                          <td>:</td>
                          <td>{SelectedVehicleData?.vehicle_model_range}</td>
                        </tr>
                        <tr className="col-md-6">
                          <td>Type</td>
                          <td>:</td>
                          <td>
                            {SelectedVehicleData?.vehicle_type_vehicleType}
                          </td>
                        </tr>
                        <tr className="col-md-6">
                          <td>Model</td>
                          <td>:</td>
                          <td>{SelectedVehicleData?.vehicle_type_model}</td>
                        </tr>
                        <tr className="col-md-6">
                          <td>Manufacter</td>
                          <td>:</td>
                          <td>
                            {SelectedVehicleData?.vehicle_type_manufacter}
                          </td>
                        </tr>
                        <tr className="col-md-6">
                          <td>GgearboxType</td>
                          <td>:</td>
                          <td>
                            {SelectedVehicleData?.vehicle_type_gearboxType}
                          </td>
                        </tr>

                        <tr className="col-md-6"></tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}
          </ModalBody>
          <ModalFooter className="p-0">
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleViewClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              Close <i className="bi bi-x-lg"></i>
            </button>
          </ModalFooter>
        </div>
      </Modal>
    </div>
  );
};

export default Vehicles;
